import $ from 'jquery'

function init() {}
function ready() {
  const $slider = $('.js-top-mv-slider')
  $slider
    .slick({
      slidesToShow: 1,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 2500,
      infinite: true,
      arrows: false,
      dots: true,
      pauseOnHover: false,
    })
    .on({
      beforeChange: function (event, slick, currentSlide, nextSlide) {
        $('.slick-slide', this).eq(currentSlide).addClass('remove-animation')
        $('.slick-slide', this)
          .eq(nextSlide)
          .addClass('add-animation' + (currentSlide + 1))
      },
      afterChange: function () {
        $('.remove-animation', this).removeClass(
          'remove-animation add-animation1 add-animation2 add-animation3 add-animation4'
        )
      },
    })
}

export default {
  init() {
    init()
    $(function () {
      ready()
    })
  },
}
